<template>
  <div>
    <Row>
      <Card shadow>
        <div style="float: left">
          <Form :model="searchForm" ref="searchForm" inline :label-width="40" @submit.native.prevent>
            <FormItem label="名称">
              <Input v-model="searchForm.name" style="min-width: 200px" />
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getTableData()">搜索</Button>
              <Button style="margin-left: 8px" @click="searchForm.name = ''">重置</Button>
            </FormItem>
          </Form>
        </div>
        <div style="text-align: right">
          <Button
            @click="getTableData()"
            type="primary"
            icon="md-refresh">刷新</Button>
        </div>
      </Card>
    </Row>
    <Row>
      <Card shadow>
        <List item-layout="vertical" :loading="loading">
          <ListItem v-for="item in clusters" :key="item.title">
            <ListItemMeta>
              <a slot="title" v-on:click="$router.push({name: 'container_cluster_detail', params: {id: item.id}})" style="color: #2d8cf0">{{ item.name }}</a>
              <span slot="description">
                <span v-if="item.created_user">
                  <span>部署用户：{{ item.created_user.name ? item.created_user.name : item.created_user.username }}</span>
                  <Divider type="vertical"/>
                </span>
                <span>部署时间：{{ moment(item.created_at).format('YYYY-MM-DD HH:mm:ss') }}</span>
              </span>
            </ListItemMeta>
            <div>
              <span><Badge status="success" />运行中</span>
              <Divider type="vertical"/>
              <span>容器数：{{ Object.keys(item.configs).length }}</span>
              <Divider type="vertical"/>
              <span v-if="item.stack">部署堆栈：{{ item.stack.name }}</span>
            </div>
            <!--<template slot="action">-->
              <!--<li>-->
                <!--<a style="color: #2d8cf0" v-on:click="$router.push({name: 'container_cluster_detail', params: {id: item.id}})">查看</a>-->
              <!--</li>-->
              <!--<li>-->
                <!--<a style="color: #ff9900">编辑</a>-->
              <!--</li>-->
              <!--<li>-->
                <!--<a style="color: #ed4014">销毁</a>-->
              <!--</li>-->
            <!--</template>-->
          </ListItem>
        </List>
      </Card>
    </Row>
  </div>
</template>

<script>
import { getClusters } from '@/api/container/cluster'
import moment from 'moment'

export default {
  name: 'list',
  data () {
    return {
      loading: false,
      clusters: [],
      searchForm: {
        name: ''
      },
      moment: moment
    }
  },
  created: function () {
    this.getTableData()
  },
  methods: {
    getTableData () {
      this.loading = true
      getClusters(this.searchForm).then(res => {
        this.clusters = res.data
        this.loading = false
      }).catch(res => {
        this.loading = false
        console.error(res.response)
      })
    }
  }
}
</script>

<style scoped>

</style>
